import store from '@/store'

export function setDict() {
  //这个dictList中的键名都是字典名称，即传入对应名称可获取对应list
  const dictList = [

  ]
  if(dictList.length) {
    dictList.forEach(item => {
      setTimeout(() => {
        store.dispatch('setDict', item)
      })
    })
  }

  const storeList = [
    'setProduceLocation', // 客户区域
  ]
  storeList.forEach(item => {
    setTimeout(() => {
      store.dispatch(item)
    })
  })
}